import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forYou = ['Parents of children (ages 3–10) who notice "glazed eyes" and instant rage when screens are removed.', 'Families where the iPad has become a "third parent" just to get through the day.', 'Moms and Dads feeling deep guilt about screen time but who are too tired to fight the battle alone.'];
  const notForYou = ['Parents looking for a "magic app" to solve behavior (this is a zero-tech reset).', 'Anyone unwilling to commit to a single weekend of consistency.', 'Parents who are comfortable with 4+ hours of daily passive consumption.'];
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background-alt)'
  }} data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-3xl md:text-4xl font-bold mb-12 text-center" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-3">
          Is This For You?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-4">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: 0.1
        }} className="p-6 rounded-lg" style={{
          backgroundColor: 'var(--color-background)',
          border: '1px solid var(--color-border)'
        }} data-id="element-5">
            <h3 className="text-xl font-semibold mb-6 flex items-center gap-2" style={{
            fontFamily: 'var(--font-heading)',
            color: 'var(--color-accent)'
          }} data-id="element-6">
              <CheckIcon className="w-6 h-6" data-id="element-7" />
              This is for you if...
            </h3>
            <ul className="space-y-4" data-id="element-8">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-9">
                  <CheckIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--color-accent)'
              }} data-id="element-10" />
                  <span style={{
                color: 'var(--color-text)'
              }} data-id="element-11">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: 0.2
        }} className="p-6 rounded-lg" style={{
          backgroundColor: 'var(--color-background)',
          border: '1px solid var(--color-border)'
        }} data-id="element-12">
            <h3 className="text-xl font-semibold mb-6 flex items-center gap-2" style={{
            fontFamily: 'var(--font-heading)',
            color: 'var(--color-negative)'
          }} data-id="element-13">
              <XIcon className="w-6 h-6" data-id="element-14" />
              This is NOT for you if...
            </h3>
            <ul className="space-y-4" data-id="element-15">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-16">
                  <XIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--color-negative)'
              }} data-id="element-17" />
                  <span style={{
                color: 'var(--color-text)'
              }} data-id="element-18">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}